/* ============================================
   BR4NDOM — interactions
   ============================================ */

/* ---------- Réglage : date du drop (à modifier ici) ---------- */
/* Format : année-mois-jour T heure. Le 4 du mois, à 16h (4PM) — évidemment. */
const DATE_DU_DROP = new Date('2026-07-04T16:00:00');

/* ---------- Garder la langue en naviguant ---------- */
/* Si le client est sur une langue non racine (ex. /de), on ajoute ce préfixe à
   tous les liens internes pour qu'il reste dans sa langue de page en page. */
(function () {
  var map = window.BR_LOCALES;
  var courant = window.BR_LOCALE;
  if (!map || !courant) return;
  var prefixe = (map[courant] || '/').replace(/\/+$/, '');
  if (!prefixe) return; // langue racine (fr) : rien à faire

  var racines = [];
  for (var k in map) {
    var p = (map[k] || '/').replace(/\/+$/, '');
    if (p) racines.push(p);
  }

  document.querySelectorAll('a[href^="/"]').forEach(function (a) {
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) !== '/' || href.charAt(1) === '/') return; // externe / protocole-relatif
    for (var i = 0; i < racines.length; i++) {
      if (href === racines[i] || href.indexOf(racines[i] + '/') === 0) return; // déjà préfixé
    }
    a.setAttribute('href', prefixe + href);
  });
})();

/* ---------- Intro : compteur 000 → 100, puis retrait du rideau ---------- */

const intro = document.getElementById('intro');
if (intro) {
  const introCount = document.getElementById('intro-count');
  if (introCount) {
    const DUREE_INTRO = 1900; // suit la durée du remplissage CSS (introFill)
    const departIntro = performance.now();
    const pad3 = (n) => String(n).padStart(3, '0');
    const ticIntro = (maintenant) => {
      const t = Math.min((maintenant - departIntro) / DUREE_INTRO, 1);
      introCount.textContent = pad3(Math.round(t * 100));
      if (t < 1) requestAnimationFrame(ticIntro);
    };
    requestAnimationFrame(ticIntro);
  }
  // quand le rideau a fini de monter, on le retire complètement du flux
  intro.addEventListener('animationend', (e) => {
    if (e.target === intro) intro.classList.add('intro--done');
  });
}

/* ---------- Apparition des sections au défilement ---------- */

const observateur = new IntersectionObserver(
  (entrees) => {
    entrees.forEach((entree) => {
      if (entree.isIntersecting) {
        entree.target.classList.add('visible');
        observateur.unobserve(entree.target);
      }
    });
  },
  { threshold: 0.12 }
);

document.querySelectorAll('.reveal').forEach((el) => observateur.observe(el));

/* ---------- Compte à rebours ---------- */

const countdown = document.getElementById('countdown');
if (countdown) {
  const pad = (n) => String(Math.max(0, n)).padStart(2, '0');
  const tic = () => {
    const reste = DATE_DU_DROP - new Date();
    if (reste <= 0) {
      countdown.innerHTML =
        '<div class="countdown__bloc"><div class="countdown__valeur">LIVE</div>' +
        '<div class="countdown__label">Drop 001 is out</div></div>';
      return;
    }
    document.getElementById('cd-jours').textContent = pad(Math.floor(reste / 86400000));
    document.getElementById('cd-heures').textContent = pad(Math.floor(reste / 3600000) % 24);
    document.getElementById('cd-minutes').textContent = pad(Math.floor(reste / 60000) % 60);
    document.getElementById('cd-secondes').textContent = pad(Math.floor(reste / 1000) % 60);
    setTimeout(tic, 1000);
  };
  tic();
}

/* ---------- Phrases aléatoires : gérées par i18n.js (selon la langue) ---------- */

/* ---------- Galerie recto/verso (clic = bascule, pour mobile) ---------- */

const galerie = document.getElementById('galerie-flip');
if (galerie) {
  galerie.addEventListener('click', () => galerie.classList.toggle('flip'));
}

/* ---------- Sélecteur de taille ---------- */

document.querySelectorAll('.taille').forEach((btn) => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.taille').forEach((b) => b.classList.remove('choisie'));
    btn.classList.add('choisie');
    const lien = document.getElementById('btn-acheter');
    if (lien) {
      lien.textContent = `Get it in ${btn.dataset.taille} — brandom.ch`;
    }
  });
});

/* ---------- Formulaire d'accès → renvoie vers la vraie boutique ---------- */

const formAcces = document.getElementById('form-acces');
if (formAcces) {
  formAcces.addEventListener('submit', (e) => {
    e.preventDefault();
    window.open('https://brandom.ch', '_blank', 'noopener');
    document.getElementById('acces-note').textContent =
      'Almost there — drop your email on brandom.ch to lock your spot.';
  });
}

/* ---------- DROP 000 — l'easter egg ---------- */
/* Cliquer 4 fois sur le « 4 » du logo révèle le drop qui n'a jamais existé. */

const quatre = document.getElementById('quatre-secret');
const drop000 = document.getElementById('drop000');
if (quatre && drop000) {
  let clics = 0;
  let dernierClic = 0;

  quatre.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const maintenant = Date.now();
    clics = maintenant - dernierClic < 2000 ? clics + 1 : 1;
    dernierClic = maintenant;
    if (clics >= 4) {
      clics = 0;
      drop000.classList.add('ouvert');
      document.body.style.overflow = 'hidden';
    }
  });

  document.getElementById('drop000-fermer').addEventListener('click', () => {
    drop000.classList.remove('ouvert');
    document.body.style.overflow = '';
  });
}

/* ---------- Ruban du haut : défilement continu sans couture ---------- */

const rubanTrack = document.querySelector('.ruban__track');
if (rubanTrack) {
  const base = rubanTrack.innerHTML;
  let garde = 0;
  while (rubanTrack.scrollWidth < window.innerWidth * 2 && garde < 30) {
    rubanTrack.innerHTML += base;
    garde += 1;
  }
  // on double l'ensemble : la translation de -50% boucle sans saut
  rubanTrack.innerHTML += rubanTrack.innerHTML;
}

/* ---------- Film : toujours muet, aucun contrôle de son ---------- */

/* ---------- Vidéo boomerang : avant (start→end) puis retour (end→start) ---------- */

document.querySelectorAll('video[data-pingpong]').forEach((vid) => {
  const start = parseFloat(vid.dataset.start || '0');
  const end = parseFloat(vid.dataset.end || '0') || null;
  vid.muted = true;
  vid.loop = false;
  let timer = null;
  let lastTs = null;
  const limite = () => end || vid.duration || 0;
  const stop = () => { if (timer) { clearInterval(timer); timer = null; } };

  function avant() {
    stop();
    if (vid.currentTime < start || vid.currentTime >= limite()) {
      try { vid.currentTime = start; } catch (e) {}
    }
    vid.play().catch(() => {});
    timer = setInterval(() => {
      if (vid.currentTime >= limite() - 0.05) avant_to_arriere();
    }, 40);
  }

  function avant_to_arriere() {
    stop();
    vid.pause();
    lastTs = performance.now();
    timer = setInterval(() => {
      const now = performance.now();
      const dt = (now - lastTs) / 1000;
      lastTs = now;
      let t = vid.currentTime - dt;
      if (t <= start) {
        try { vid.currentTime = start; } catch (e) {}
        avant();
        return;
      }
      try { vid.currentTime = t; } catch (e) {}
    }, 33);
  }

  function demarrer() { try { vid.currentTime = start; } catch (e) {} avant(); }
  if (vid.readyState >= 1) demarrer();
  else vid.addEventListener('loadedmetadata', demarrer, { once: true });
});
